//******************IMPORT******************/
import jesus from "../img/jesus.png";

//******************ARRAY*****************/

const data = [
  {
    name: "Jorge Jesus",
    number: "Boss",
    photo: jesus,
    position: "Technical Director",
  },
  {
    name: "Altay Bayındır",
    number: 1,
    photo:
      "https://www.fenerbahce.org/getmedia/d01b91f9-b14e-4141-8be3-646bc4b4471c/altayportre.png?width=400&height=380&ext=.png",
    position: "Goalkeeper",
  },
  {
    name: "Osman Ertuğrul Çetin",
    number: 54,
    photo:
      "https://www.fenerbahce.org/getmedia/f7fd7d28-92bc-4513-9e6e-16e96472af28/etoportre_1.png?width=400&height=380&ext=.png",
    position: "Goalkeeper",
  },
  {
    name: "Atilla Szalai",
    number: 41,
    photo:
      "https://www.fenerbahce.org/getmedia/415c302c-73f9-48d6-aa3f-3bee1930aac7/atiportre.png?width=380&height=400&ext=.png",
    position: "Defender",
  },
  {
    name: "Serdar Aziz",
    number: 4,
    photo:
      "https://www.fenerbahce.org/getmedia/99a55004-e5d9-48de-9ce8-be6bdf92cdc8/serdarportre.png?width=400&height=380&ext=.png",
    position: "Defender",
  },
  {
    name: "Gustavo Henrique",
    number: 2,
    photo:
      "https://www.fenerbahce.org/getmedia/d3e25109-691b-4f6b-a994-b50700edcafe/gustavoprorte.png?width=380&height=400&ext=.png",
    position: "Defender",
  },
  {
    name: "Luan Peres",
    number: 28,
    photo:
      "https://www.fenerbahce.org/getmedia/044b060b-5f17-477e-88c1-acc25beb8ef5/peresportre.png?width=380&height=400&ext=.png",
    position: "Defender",
  },
  {
    name: "Bright Osayi-Samuel",
    number: 21,
    photo:
      "https://www.fenerbahce.org/getmedia/7950087a-b76a-412b-9a7b-e683931ddcf5/portrefutbolcular-(17).png?width=380&height=400&ext=.png",
    position: "Defender",
  },
  {
    name: "Ferdi Kadıoğlu",
    number: 7,
    photo:
      "https://www.fenerbahce.org/getmedia/fce053f8-2ed5-42fb-9c7c-a6084aed82ad/portrefutbolcular-(9).png?width=400&height=380&ext=.png",
    position: "Defender",
  },
  {
    name: "Ezgjan Alioski",
    number: 6,
    photo:
      "https://www.fenerbahce.org/getmedia/686acb67-1cbe-45c7-8322-4010f14e3117/alioskivesikalik.png?width=400&height=380&ext=.png",
    position: "Defender",
  },
  {
    name: "Willian Arao",
    number: 5,
    photo:
      "https://www.fenerbahce.org/getmedia/fb7be4ec-decc-404e-95e1-b45d99bc3664/portrefutbolcular-(23).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Miguel Crespo",
    number: 27,
    photo:
      "https://www.fenerbahce.org/getmedia/b5a76f55-c135-460a-944d-17ef6ce68132/portrefutbolcular-(5).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Mert Hakan Yandaş",
    number: 8,
    photo:
      "https://www.fenerbahce.org/getmedia/67aefec0-930b-4083-9c3b-191d1ee8617a/portrefutbolcular-(16).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Miha Zajc",
    number: 26,
    photo:
      "https://www.fenerbahce.org/getmedia/522ee9cb-7b0b-4687-acb1-a3f875ec2d12/portrefutbolcular-(25).png?width=400&height=380&ext=.png",
    position: "Midfielder",
  },
  {
    name: "İrfan Can Kahveci",
    number: 17,
    photo:
      "https://www.fenerbahce.org/getmedia/29daa6a4-2a53-4e04-9ca4-9480bf951f5e/portrefutbolcular-(11).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Arda Güler",
    number: 10,
    photo:
      "https://www.fenerbahce.org/getmedia/ad535473-bf22-4205-a2a4-cbe5c67810aa/portrefutbolcular-(1).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Lincoln Henrique",
    number: 18,
    photo:
      "https://www.fenerbahce.org/getmedia/0d702a9c-1fa0-4289-a56a-7cbfdf5c620d/portrefutbolcular-(15).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "İsmail Yüksek",
    number: 80,
    photo:
      "https://www.fenerbahce.org/getmedia/b8b1607f-080c-46ff-81e4-86081d444649/portrefutbolcular-(13).png?width=400&height=380&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Emre Mor",
    number: 99,
    photo:
      "https://www.fenerbahce.org/getmedia/18b6ce0f-d94a-4dde-8223-80f7f95d481f/portrefutbolcular-(7).png?width=380&height=400&ext=.png",
    position: "Midfielder",
  },
  {
    name: "Diego Rossi",
    number: 9,
    photo:
      "https://www.fenerbahce.org/getmedia/5f41edaf-c8b5-4aa8-a252-97de2237d445/portrefutbolcular-(20).png?width=400&height=380&ext=.png",
    position: "Striker",
  },
  {
    name: "Enner Valencia",
    number: 13,
    photo:
      "https://www.fenerbahce.org/getmedia/047081f4-585f-49d6-a8c7-6578926acc74/portrefutbolcular-(8).png?width=380&height=400&ext=.png",
    position: "Striker",
  },
  {
    name: "Joao Pedro",
    number: 20,
    photo:
      "https://www.fenerbahce.org/getmedia/bb52401b-3507-49ee-a9c1-61837aa48959/portrefutbolcular-(18).png?width=380&height=400&ext=.png",
    position: "Striker",
  },
  {
    name: "Joshua King",
    number: 15,
    photo:
      "https://www.fenerbahce.org/getmedia/0e05f000-ec07-47e6-9131-ad1fde3a7357/portrefutbolcular-(14).png?width=400&height=380&ext=.png",
    position: "Striker",
  },
  {
    name: "Michy Batshuayi",
    number: 23,
    photo:
      "https://www.fenerbahce.org/getmedia/a2e098a9-ccaf-430b-93e0-ea8288efd346/michy_basthuayi.png?width=400&height=380&ext=.png",
    position: "Striker",
  },
  {
    name: "Serdar Dursun",
    number: 19,
    photo:
      "https://www.fenerbahce.org/getmedia/81aaac88-78c0-4ea9-b300-39ceaa220443/portrefutbolcular-(21).png?width=400&height=380&ext=.png",
    position: "Striker",
  },
];

export default data;
